import {FC, useState} from "react"
import {Scanner} from "../components/Scanner"
import {UpsellSelector} from "../components/UpsellSelect"
import {AdminPageCard} from "../components/admin/AdminPageCard";

export const ScannerPage: FC = () => {

    const [selectedServiceId, setSelectedServiceId] = useState<string>("");

    const handleServiceSelect = (id: string) => {
        setSelectedServiceId(id);
    };

    const handleBackToSelectionScreen = () => {
        setSelectedServiceId("")
    }

    return (
        <AdminPageCard title="Scanner" className="max-h-[calc(100vh-200px)] overflow-hidden">
            {!selectedServiceId && <UpsellSelector onSelect={handleServiceSelect} />}
            {selectedServiceId && <Scanner additionalServiceId={selectedServiceId} onBackToSelectionScreen={handleBackToSelectionScreen}/>}
        </AdminPageCard>
    );
};
